import { create } from 'zustand';

type PushOnboardingSlice = {
  // When true, the reliability onboarding shows even if the user already dismissed it.
  // Lets Settings re-open the one-time onboarding on demand (e.g. after an accidental "Done").
  forceShow: boolean;
  // Whether the onboarding sheet is on screen right now. Written by the sheet itself, read by
  // anything else that wants to talk to the user — the Play rating card would otherwise land on
  // top of a permission flow the user cannot postpone (the system grants no second prompt).
  visible: boolean;
  show: () => void;
  hide: () => void;
  setVisible: (visible: boolean) => void;
};

export const usePushOnboardingStore = create<PushOnboardingSlice>((set) => ({
  forceShow: false,
  visible: false,
  show: () => set({ forceShow: true }),
  hide: () => set({ forceShow: false }),
  setVisible: (visible) => set({ visible }),
}));
